import React from 'react';
import { ArrowRight } from 'lucide-react';
import { whatsappLink } from '../data/mock';

const portfolioLinks = [
  { label: 'Portfólio de Vídeos', href: '#portfolio' },
  { label: 'Portfólio de Estáticos', href: '#portfolio-posts' },
];

export default function Transform() {
  return (
    <section className="py-24 lg:py-32 bg-[color:var(--brown-900)] border-y border-[color:var(--gold-500)]/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
        <div>
          <h2 className="font-serif text-[2.6rem] md:text-[3.4rem] lg:text-[4rem] leading-[1.05] text-[color:var(--cream-100)]">
            Transformo{' '}
            <span className="italic text-[color:var(--gold-400)]">2 horas</span>{' '}
            do seu mês em um mês inteiro de{' '}
            <span className="italic">presença digital.</span>
          </h2>
        </div>

        <div className="lg:pt-4">
          <div className="space-y-6 text-[color:var(--cream-100)]/85 text-base md:text-lg leading-relaxed max-w-xl">
            <p>
              Você não precisa passar horas pensando em conteúdo. Nós cuidamos
              do planejamento, produção, gravações, edição, publicação e
              acompanhamento das redes sociais para que você possa focar no que
              realmente importa: o seu negócio.
            </p>
            <p>
              Além disso te ajudamos a impulsionar o seu negócio ou serviço
              através do tráfego pago.
            </p>
          </div>

          <div className="mt-10 space-y-4">
            {portfolioLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="group flex items-center gap-3 w-fit"
              >
                <span className="font-serif italic text-xl md:text-2xl text-[color:var(--gold-400)] border-b border-[color:var(--gold-400)]/30 pb-1 group-hover:border-[color:var(--gold-400)] transition-colors">
                  {link.label}
                </span>
                <ArrowRight
                  size={20}
                  className="text-[color:var(--gold-400)] group-hover:translate-x-1 transition-transform"
                />
              </a>
            ))}
          </div>

          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-12 inline-flex items-center px-10 py-4 rounded-full bg-[color:var(--cream-100)] text-[color:var(--brown-900)] text-[11px] tracking-widest-2 uppercase font-medium hover:bg-white transition-colors"
          >
            Fale conosco
          </a>
        </div>
      </div>
    </section>
  );
}
